import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import React from 'react';

export const MultipleFilesPanel = ({ count }: any) => {
  return (
    <div id="multiplefilespanel-wrapper" className="flex flex-col justify-center items-center h-4/5">
      <RMSvgIcon id="multiplefilespanel-svg-icon" name="MultipleFiles" height="5rem" width="5rem" />
      <text id="multiplefilespanel-count-text">
        [<span id="multiplefilespanel-count" className="text-[#006AF5]">{count}</span>] items selected
      </text>
      <div id="multiplefilespanel-info-box" className="mt-2 px-2 py-1 bg-[#AACDFC] border-solid border-[0.12rem] border-[#006AF5]">
        <RMSvgIcon id="multiplefilespanel-svg-info-icon" name="Info" fill="#006AF5" />
        &nbsp;Select single file to get more information.
      </div>
    </div>
  );
};
